// find status definitions on https://bagonboard.atlassian.net/wiki/spaces/PRD/pages/958496769/Definitions+for+bag+service+invoice+and+order+status
const SERVICE_STATUS = {
  ON_VERIFICATION: 'onVerification',
  PENDING        : 'pending',
  ASSIGNED       : 'assigned',
  PROCESSING     : 'processing',
  COMPLETED      : 'completed',
  BLOCKED        : 'blocked',
  CANCELLED      : 'cancelled',
  DECLINED       : 'declined',
} as const;

export type ServiceStatus = typeof SERVICE_STATUS;

export default SERVICE_STATUS;
